export function encodeAppName(name) {
  return name.replace(/['`´‘’]/g, '').replace(/<\/?.*?>/g, ' ').split(/\W/).filter(s => s && s.trim() !== '').map(s => s.toLowerCase().trim()).join('-');
}